import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "navigation/insurance-offer",
  "use": "navigation/insurance-offer-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"navigation/insurance-offer\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.7.903 8.459 7.89l-1.69-2.028a1 1 0 0 0-1.537 1.28l2.5 3a1 1 0 0 0 1.568-.04l6-8a1 1 0 1 0-1.6-1.2v.001zm.3 7.1a1 1 0 0 0-1 1v4H3v-10h4a1 1 0 0 0 0-2H2.5a1.5 1.5 0 0 0-1.5 1.5v11a1.5 1.5 0 0 0 1.5 1.5h11a1.5 1.5 0 0 0 1.5-1.5v-4.5a1 1 0 0 0-1-1z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol